import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MaskIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M2 1.79852V8.10067C2 9.9564 3.28401 13.6529 5.31672 14.4828C7.00588 15.1724 8.99412 15.1724 10.6833 14.4828C12.716 13.6529 14 9.9564 14 8.10067V1.79852C14 1.17879 13.172 0.796002 12.5212 1.11485C9.73832 2.47829 6.26168 2.47829 3.47877 1.11485C2.82797 0.796002 2 1.17879 2 1.79852ZM4.00919 9.59233C4.3246 11.1072 5.37504 13 8 13C10.625 13 11.6754 11.1072 11.9908 9.59233C12.0818 9.15537 11.4789 8.87232 10.9829 9.05778C10.1449 9.37111 9.04472 9.67093 8 9.67093C6.95528 9.67093 5.85514 9.37111 5.01712 9.05778C4.52112 8.87232 3.91821 9.15537 4.00919 9.59233ZM5.27256 7C6.68028 7 6.94103 5.6357 6.98916 5.16072C6.99666 5.08669 6.92107 5.03686 6.85259 5.06594C6.54048 5.19848 5.77757 5.4858 5 5.5C4.40621 5.51084 3.80387 5.28638 3.38721 5.1311C3.30963 5.1022 3.23847 5.07568 3.17502 5.05353C3.10027 5.02744 3.03612 5.09781 3.06698 5.17072C3.32932 5.79056 4.03629 7 5.27256 7ZM12.9892 5.16072C12.941 5.6357 12.6803 7 11.2726 7C10.0363 7 9.32932 5.79056 9.06698 5.17072C9.03612 5.09781 9.10027 5.02744 9.17502 5.05353C9.23847 5.07568 9.30962 5.10219 9.38721 5.1311C9.80387 5.28638 10.4062 5.51084 11 5.5C11.7776 5.4858 12.5405 5.19848 12.8526 5.06594C12.9211 5.03686 12.9967 5.08669 12.9892 5.16072Z"
		></path>
	</svg>
))
